import { Application, Controller } from "@hotwired/stimulus";
import axios from "@/modules/axios";

class PaidPurchaseContractsController extends Controller {
  static targets = ["tableBody", "returnAmount", "returnedAmount", "selectBox"];

  index() {
    const projectSlug = this.tableBodyTarget.getAttribute('data-project-slug');
    const returnOperationId = this.selectBoxTarget.value;
    const returnAmountTag = this.returnAmountTarget;
    const returnedAmountTag = this.returnedAmountTarget;
    const returnAmountsUrl = `/api/v1/admin/return_amounts?project_slug=${projectSlug}&return_operation_id=${returnOperationId}`;
    const returnAmountTags = [...document.getElementsByClassName('return-amount')];

    axios.get(returnAmountsUrl)
      .then(response => {
        returnAmountTag.textContent = response.data.totalReturnAmount;
        returnedAmountTag.textContent = response.data.totalReturnedAmount;

        const returnAmounts = response.data.returnAmounts;
        returnAmountTags.map((tag) => {
          tag.innerHTML = returnAmounts[tag.getAttribute('data-purchase-contract-id')]
        })
      })
      .catch((error) => {
        console.log(error);
        throw new Error('データの取得に失敗しました');
      });
  }
}

// Registered in admin.js
export { PaidPurchaseContractsController };
